import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import IconButton from '@components/IconButton';

import { AssessmentType } from 'generated/types';

import { ErrorCode, FormattedError } from '../../../models/error';
import { AssessmentConsentForm, BhaQrCode } from './Bha';

interface PatientDialogProps {
  onClose: () => void;
  vitall_patient_id: string;
  patient_id: string;
  /** Patient first and last name */
  name?: string | null;
}

export default function PatientDialog({
  onClose,
  vitall_patient_id,
  patient_id,
  name,
}: PatientDialogProps) {
  const assessmentType: AssessmentType = AssessmentType.BHA;

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <IconButton
        onClick={handleClose}
        name="xmark"
        iconType="fas"
        sx={{
          position: 'absolute',
          top: '10px',
          right: '10px',
        }}
      />
      <ErrorBoundary
        fallbackRender={({ resetErrorBoundary, error }) => {
          return error instanceof FormattedError &&
            error.code === ErrorCode.ConsentRequired ? (
            <AssessmentConsentForm
              name={name}
              patient_id={patient_id}
              onDidConsent={resetErrorBoundary}
            />
          ) : (
            <ErrorBoundaryFallback
              error={error}
              resetErrorBoundary={resetErrorBoundary}
            />
          );
        }}
      >
        {/* QR code will throw error if user has not consented */}
        <BhaQrCode
          vitall_patient_id={vitall_patient_id}
          assessmentType={assessmentType}
        />
      </ErrorBoundary>
    </>
  );
}
